import { useDispatch } from 'react-redux';
import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import {
  CampaignContributionTableHeader,
  CampaignContributionTableSort,
  SortInput,
} from 'modules/iterableGoals/types';
import { setCampaignContributionSort } from 'modules/iterableGoals/ducks/actions';
import { getTableColumns } from 'modules/iterableGoals/utils';
import { MAP_CAMPAIGN_CONTRIBUTIONS_TABLE_HEADER_AND_SORT_ID } from 'modules/iterableGoals/constants';
import {
  TABLE_GQL_SORT_DIRECTION_ENUM_MAP,
  TABLE_SORT_DIRECTIONS,
} from 'constants/sortDirectionsEnum';
import { StyledTableHeader } from './Styled';

type HeaderPropType = {
  sort: SortInput;
};

export const Header = ({ sort }: HeaderPropType) => {
  const { t } = useGoalsTranslations();
  const dispatch = useDispatch();

  return (
    <StyledTableHeader
      columns={getTableColumns(t)}
      sortedBy={MAP_CAMPAIGN_CONTRIBUTIONS_TABLE_HEADER_AND_SORT_ID[sort.sortBy]}
      sortDirection={TABLE_GQL_SORT_DIRECTION_ENUM_MAP[sort.sortDirection]}
      setSortDirection={(newSortDirection) =>
        dispatch(
          setCampaignContributionSort({
            ...sort,
            sortDirection:
              TABLE_GQL_SORT_DIRECTION_ENUM_MAP[newSortDirection as TABLE_SORT_DIRECTIONS],
          }),
        )
      }
      setSortedBy={(newSortBy) =>
        dispatch(
          setCampaignContributionSort({
            ...sort,
            sortBy:
              MAP_CAMPAIGN_CONTRIBUTIONS_TABLE_HEADER_AND_SORT_ID[
                newSortBy as CampaignContributionTableHeader
              ] || CampaignContributionTableSort.STATUS,
          }),
        )
      }
    />
  );
};
